import Swal from "sweetalert2";

const SweetAlerts = {
  info: (title, text, options = {}) => {
    return Swal.fire({
      icon: "info",
      title,
      text,
      confirmButtonText: "OK",
      ...options,
    });
  },

  success: (title, text, options = {}) => {
    return Swal.fire({
      icon: "success",
      title,
      text,
      confirmButtonText: "OK",
      ...options,
    });
  },

  error: (title, text, options = {}) => {
    return Swal.fire({
      icon: "error",
      title,
      text,
      confirmButtonText: "OK",
      ...options,
    });
  },

  warning: (title, text, options = {}) => {
    return Swal.fire({
      icon: "warning",
      title,
      text,
      confirmButtonText: "OK",
      ...options,
    });
  },

  confirm: (title, text, confirmButtonText = "Sí", cancelButtonText = "No", options = {}) => {
    return Swal.fire({
      icon: "question",
      title,
      text,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      ...options,
    });
  },

  loading: (title = "Cargando...", text = "", options = {}) => {
    return Swal.fire({
      title,
      text,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
      ...options,
    });
  },

  close: () => {
    Swal.close();
  },

  toast: (icon, title, timer = 3000, options = {}) => {
    return Swal.fire({
      icon,
      title,
      timer,
      timerProgressBar: true,
      showConfirmButton: false,
      position: 'top-end',
      toast: true,
      ...options,
    });
  },

  actions: {
    deleteTicket: (ticketId, options = {}) => {
      return SweetAlerts.confirm("Eliminar Ticket", `¿Estás seguro de eliminar el ticket #${ticketId}?`, "Sí", "No", options);
    },
    deleteGeneric: (str, options = {}) => {
      return SweetAlerts.confirm("Eliminar ", `¿Estás seguro de eliminar ${str}?`, "Sí", "No", options);
    },
    closeTicket: (ticketId, options = {}) => {
      return SweetAlerts.confirm("Cerrar Ticket", `¿Deseas cerrar el ticket #${ticketId}? Esta acción no se puede deshacer.`, "Sí", "No", options);
    },
    reOpenTicket: (ticketId, options = {}) => {
      return SweetAlerts.confirm("Reabrir Ticket", `¿Quieres reabrir el ticket #${ticketId}?`, "Sí", "No", options);
    },
    markAsPaid: (ticketId, options = {}) => {
      return SweetAlerts.confirm("Marcar como Pagado", `¿Confirmas que el ticket #${ticketId} ha sido pagado?`, "Sí", "No", options);
    },
    assignTicket: (ticketId, userName, options = {}) => {
      return SweetAlerts.confirm("Asignar Ticket", `¿Quieres asignar el ticket #${ticketId} a ${userName}?`, "Sí", "No", options);
    },
  },
};

export default SweetAlerts;
